import { PropsWithChildren } from 'react';
import { useLocalStorage } from 'react-use';

import { ClientSearchFilterType } from '../ClientSearchFilterToolbar/ClientSearchFilterToolbar.types';
import { ClientListPageContext } from './ClientListPage.context';

// Define the key for local storage
const SESSION_STORAGE_KEY = 'clientListPageFilters';

// Define the initial value
const initialFilterValue: Record<ClientSearchFilterType, string[]> = {
  subBrand: [],
  relationshipOwner: [],
  state: [],
  team: [],
};

function useClientListPageContextValue(): ClientListPageContext {
  // Use useLocalStorage to persist filter values
  const [filterValue, setFilterValue] = useLocalStorage<
    Record<ClientSearchFilterType, string[]>
  >(SESSION_STORAGE_KEY, initialFilterValue);

  return {
    // Provide the state value from local storage, falling back to initial if somehow null
    filterValue: filterValue ?? initialFilterValue,
    // Provide the setter function from useLocalStorage
    setFilterValue,
  };
}

export function ClientListPageProvider({ children }: PropsWithChildren) {
  const value = useClientListPageContextValue();

  return (
    <ClientListPageContext.Provider value={value}>
      {children}
    </ClientListPageContext.Provider>
  );
}
